<template>
  <div id="SectionComplexity">
    <UIContainer>
      <SectionTitle class="SectionComplexity__title">
        <template #title> Clarity in a Complex World </template>
      </SectionTitle>

      <div class="SectionComplexity__sections">
        <div
          class="SectionComplexity__section"
          v-for="section in sections"
          :key="section.title"
        >
          <img :src="section.image" alt="Section Complexity" loading="lazy" />
          <h3 class="SectionComplexity__section-title">{{ section.title }}</h3>
          <p class="SectionComplexity__section-description">
            {{ section.description }}
          </p>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import complex1 from './assets/complex1.png'
import complex2 from './assets/complex2.png'
import complex3 from './assets/complex3.png'

interface Section {
  title: string
  image: string
  description: string
}

const sections: Section[] = [
  {
    title: 'Gain certainty',
    image: complex1,
    description: 'Get a definitive answer based on the latest EU regulations.',
  },
  {
    title: 'Save time',
    image: complex2,
    description:
      'Avoid hours of complex legal research with a simple, guided questionnaire.',
  },
  {
    title: 'Plan your next steps',
    image: complex3,
    description:
      'Understand your obligations to prepare your data and strategy.',
  },
]
</script>

<style lang="scss" scoped>
#SectionComplexity {
  .SectionComplexity__title {
    text-align: center;
    margin: 0 auto 1rem;
    max-width: 48rem;
  }

  .SectionComplexity__sections {
    margin-top: 4rem;
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;

    @include md {
      gap: 3rem;
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .SectionComplexity__section {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .SectionComplexity__section-title {
    @include font-size-16px();
    margin-top: 1rem;
    font-weight: 600;
    color: $color-ui-gray-cool-900;
    margin-bottom: 4px;

    @include md {
      @include font-size-18px();
    }
  }

  .SectionComplexity__section-description {
    @include font-size-14px();
    color: $color-ui-gray-cool-600;
    max-width: 25.3125rem;

    @include md {
      @include font-size-16px();
    }
  }
}
</style>
